import { HTMLExtUtils } from '@ssml-editor/core';
import { SUB_TYPE } from './constant.js';

const subElementToHtml = ({
  element,
  childrenHtml
}) => {
  const { mark, alias } = element;
  return HTMLExtUtils.createElementAsString(
    SUB_TYPE,
    true,
    false,
    {
      mark,
      alias
    },
    childrenHtml
  );
};

export { subElementToHtml };
//# sourceMappingURL=element-to-html.js.map
